var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"disabled":_vm.disabled,"item-text":_vm.optionConfig.label,"item-value":_vm.optionConfig.entityAttributeName,"items":_vm.itemList,"rules":_vm.ruleList,"outlined":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }